<div class="activity-outer basic-tabs common-booking-payment crm-payment-tabs">
<p-table [value]="paymentList" id="tbl-payment" [tableStyle]="{ 'min-width': '50rem' }" [resizableColumns]="true" columnResizeMode="expand">
    <ng-template pTemplate="header">
        <tr>
            <th scope="col">Invoice Number</th>
            <th scope="col">Payment Method</th>
            <th scope="col">Company</th>
            <th scope="col">Parking Lot</th>
            <th scope="col">Time Zone</th>
            <th scope="col">Received ($)</th>
            <th scope="col">Payment Mode</th>
            <th scope="col">Received Date & Time</th>
            <th scope="col">Refunded ($)</th>
            <th scope="col">Refunded Date & Time</th>
            <th scope="col">Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
            <td>
                <div class="big-parking">
                    <h5>{{product.invoiceNumber}}</h5>

                </div>
            </td>
            <td>
                <div class="big-parking">
                    <h5>
                        <ng-container *ngIf="!(product.paymentBy === '' || product.paymentBy === null); else noPayment">
                            <span>{{product.paymentMethodType}} - XXXX - </span>{{product.paymentBy}}
                        </ng-container>
                        <ng-template #noPayment>
                            <span>-</span>
                        </ng-template>
                    </h5>
                </div>
            </td>
            <td>
                <div class="big-parking">
                    <h5>{{product.companyName}}</h5>

                </div>
            </td>
            <td>
                <div class="big-parking">
                    <h5>{{product.parkingLotName}}</h5>
                    <p> {{product.parkingLotAddress}}</p>
                </div>
            </td>
            <td>
                <div class="big-parking">
                    <h5>{{product?.timeZone ? getTimeZoneAbbreviation(product?.timeZone) : '-'}}</h5>
                </div>
            </td>
            <td>
                <div class="big-parking" class="custom-green">
                    <h5>{{product.receivedAmount}}</h5>

                </div>
            </td>
            <td>
                <div>
                    <p>
                        {{product.bookingPaymentMode | paymentModeValue}}
                    </p>
                </div>
             </td>
            <td>
                <div class="big-parking">
                    <h5>{{ product.receivedDate ? (product.receivedDate) : '-' }}</h5>
                </div>
            </td>
            <td>
                <div class="big-parking">
                    <h5 [ngClass]="{'custom-red': (product.refundAmount !== 0)}">{{product.refundAmount || '-'}}</h5>
                </div>
            </td>
            <td>
                <div class="big-parking">
                    <h5>{{ product.refundDate ? (product.refundDate | luxonFormat) : '-' }}</h5>
                </div>
            </td>
            <td>
                <div class="action-item">
                    <div class="export-btn" (click)="showData(product);menu.toggle($event)">
                        <img src="assets/images/dot.svg" alt="" />
                    </div>
                </div>   
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
        <tr class="no-border">
            <td class="no-record" colspan="10">
                No Record Found
            </td>
        </tr>
    </ng-template>
</p-table>
</div>
<div class="card common-content-end custom-pagination3" *ngIf="paymentList?.length > 0">
    <p-paginator [rows]="itemsPerPage" [first]="paymentCurrentSkip" [totalRecords]="totalPaymentRecords"
        (onPageChange)="onPagePaymentList($event)"></p-paginator>
</div>
<div class="custom-export"><p-menu #menu [model]="items" [popup]="true"></p-menu></div>